import type { StringDict } from "@/i18n/ui";

const dict: StringDict = {
  "url(#caeBar)": "url(#caeBar)",
  "hubGlow": "hubGlow",
  "url(#hubGlow)": "url(#hubGlow)",
  "all .3s ease": "all .3s ease",
  "FOR CREATORS & INFLUENCERS": "FÜR CREATOR & INFLUENCER",
  "crsFrame": "crsFrame",
  "crsBottle": "crsBottle",
  "crsGlass": "crsGlass",
  "crsSoft": "crsSoft",
  "url(#crsBottle)": "url(#crsBottle)",
  "url(#crsGlass)": "url(#crsGlass)",
  "url(#crsFrame)": "url(#crsFrame)",
  "url(#crsSoft)": "url(#crsSoft)",
  "outlineDark": "outlineDark",
  "onYellowPrimary": "onYellowPrimary",
  "onYellowSecondary": "onYellowSecondary",
  "[&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:transition-colors": "[&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:transition-colors",
  "CtaButton": "CtaButton",
  "className": "className",
  "Mitgo": "Mitgo",
  "Admitad": "Admitad",
  "Takeads": "Takeads",
  "Tapfiliate": "Tapfiliate",
  "Convertsocial": "Convertsocial",
  "Fairsavings": "Fairsavings",
  "Checkrewards": "Checkrewards",
  "Takefluence": "Takefluence",
  "Mitgame": "Mitgame",
  "Takedeals": "Takedeals",
  "Zyntent": "Zyntent",
  "Trendweave": "Trendweave",
  "oklch(0.96 0.014 95)": "oklch(0.96 0.014 95)",
  "oklch(0.9 0.006 95)": "oklch(0.9 0.006 95)",
  "oklch(0.965 0.045 100)": "oklch(0.965 0.045 100)",
  "oklch(0.945 0.075 100)": "oklch(0.945 0.075 100)",
  "oklch(0.2 0.01 260)": "oklch(0.2 0.01 260)",
  "oklch(0.93 0.02 95)": "oklch(0.93 0.02 95)",
  "oklch(0.85 0.16 96)": "oklch(0.85 0.16 96)",
  "url(#cat-sea)": "url(#cat-sea)",
  "url(#cat-hl)": "url(#cat-hl)",
  "oklch(0.975 0.035 100)": "oklch(0.975 0.035 100)",
  "oklch(0.2 0.01 260 / 0.8)": "oklch(0.2 0.01 260 / 0.8)",
  "oklch(0.2 0.01 260 / 0.14)": "oklch(0.2 0.01 260 / 0.14)",
  "motion-safe:transition-[fill,stroke,stroke-width] motion-safe:duration-300": "motion-safe:transition-[fill,stroke,stroke-width] motion-safe:duration-300",
  "oklch(0.2 0.01 260 / 0.45)": "oklch(0.2 0.01 260 / 0.45)",
  "ml-auto h-4 w-4 shrink-0": "ml-auto h-4 w-4 shrink-0",
  "(selected)": "(ausgewählt)",
  "./Container": "./Container",
  "./SocialIcons": "./SocialIcons",
  "United Kingdom": "Vereinigtes Königreich",
  "France": "Frankreich",
  "Spain": "Spanien",
  "Uzbekistan": "Usbekistan",
  "Kazakhstan": "Kasachstan",
  "w-full max-w-[420px]": "w-full max-w-[420px]",
  "url(#globe-halo)": "url(#globe-halo)",
  "url(#globe-body)": "url(#globe-body)",
  "url(#globe-clip)": "url(#globe-clip)",
  "url(#globe-sheen)": "url(#globe-sheen)",
  "./LanguageSwitcher": "./LanguageSwitcher",
  "./MegaMenuPromo": "./MegaMenuPromo",
  "Brands mega menu": "Mega-Menü für Marken",
  "Agencies mega menu": "Mega-Menü für Agenturen",
  "Brand & Marketing Agency": "Marken- & Marketingagentur",
  "Creator & Publisher Agency": "Creator- & Publisher-Agentur",
  "technologyPartner": "technologyPartner",
  "brandMarketingAgency": "brandMarketingAgency",
  "creatorPublisherAgency": "creatorPublisherAgency",
  "Creator Lead": "Creator-Anfrage",
  "Turn Your Content into Earnings": "Verwandeln Sie Ihre Inhalte in Einnahmen",
  "Share your main channel and contact details to join relevant brand campaigns.": "Teilen Sie Ihren Hauptkanal und Ihre Kontaktdaten mit, um an passenden Markenkampagnen teilzunehmen.",
  "Technology Partner Lead": "Technologiepartner-Anfrage",
  "FOR TECHNOLOGY PARTNERS / API": "FÜR TECHNOLOGIEPARTNER / API",
  "Discuss a Technology Partnership": "Über eine Technologiepartnerschaft sprechen",
  "Connect Your Platform to Catuik": "Verbinden Sie Ihre Plattform mit Catuik",
  "Agency Partnership Lead": "Agenturpartnerschafts-Anfrage",
  "Discuss an Agency Partnership": "Über eine Agenturpartnerschaft sprechen",
  "Grow Your Agency with Managed Campaign Delivery": "Lassen Sie Ihre Agentur mit betreuter Kampagnenabwicklung wachsen",
  "Bring the client brief, keep the relationship and strategic lead, and let Catuik manage campaign delivery.": "Bringen Sie das Kunden-Briefing mit, behalten Sie die Beziehung und strategische Führung, und lassen Sie Catuik die Kampagnenabwicklung übernehmen.",
  "Creator & Publisher Agency Lead": "Creator- & Publisher-Agentur-Anfrage",
  "Discuss a Creator Agency Partnership": "Über eine Creator-Agenturpartnerschaft sprechen",
  "Connect Your Creator Portfolio to Catuik": "Verbinden Sie Ihr Creator-Portfolio mit Catuik",
  "Share your portfolio to access suitable campaigns, better rates, and dedicated support.": "Teilen Sie Ihr Portfolio, um Zugang zu passenden Kampagnen, besseren Konditionen und persönlichem Support zu erhalten.",
  "Tell Us About Your Agency": "Erzählen Sie uns von Ihrer Agentur",
  "Find the Right Partnership Model for Your Agency": "Finden Sie das passende Partnerschaftsmodell für Ihre Agentur",
  "fullName": "fullName",
  "agencyAudience": "agencyAudience",
  "useLeadCapture must be used inside LeadCaptureProvider": "useLeadCapture must be used inside LeadCaptureProvider",
  "h-auto w-full max-w-[240px]": "h-auto w-full max-w-[240px]",
  "url(#lcm-g)": "url(#lcm-g)",
  "Brand Lead": "Marken-Anfrage",
  "[data-cta]": "[data-cta]",
  "section, [data-section]": "section, [data-section]",
  "url(#pesoft)": "url(#pesoft)",
  "add creator": "Creator hinzufügen",
  "url(#peearn)": "url(#peearn)",
  "Support": "Support",
  "Payouts": "Auszahlungen",
  "mkSoft": "mkSoft",
  "url(#mkSoft)": "url(#mkSoft)",
  "./Header": "./Header",
  "./Footer": "./Footer",
  "./CookieBanner": "./CookieBanner",
  "FOR SME BRANDS": "FÜR KMU-MARKEN",
  "Partner sourcing": "Partnersuche",
  "Coordination": "Koordination",
  "Negotiations": "Verhandlungen",
  "Operations": "Operativer Betrieb",
  "url(#smsoft)": "url(#smsoft)",
  "team extension": "Teamerweiterung",
  "url(#smgrow)": "url(#smgrow)",
  "continue reading": "weiterlesen",
  "ed-cue h-3.5 w-3.5": "ed-cue h-3.5 w-3.5",
  "Useful materials on this topic": "Nützliche Materialien zu diesem Thema",
  "Close promotion": "Werbung schließen",
  "Link copied": "Link kopiert",
  "Share": "Teilen",
  "Article topics": "Artikelthemen",
  "Hide topics": "Themen ausblenden",
  "More topics": "Weitere Themen",
  "you@company.com": "sie@unternehmen.de",
  "Ukraine": "Ukraine",
  "Turkmenistan": "Turkmenistan",
  "Turkey": "Türkei",
  "Tunisia": "Tunesien",
  "Tajikistan": "Tadschikistan",
  "Syria": "Syrien",
  "Switzerland": "Schweiz",
  "Sweden": "Schweden",
  "Slovakia": "Slowakei",
  "Slovenia": "Slowenien",
  "Serbia": "Serbien",
  "Saudi Arabia": "Saudi-Arabien",
  "Russia": "Russland",
  "Romania": "Rumänien",
  "Portugal": "Portugal",
  "Pakistan": "Pakistan",
  "Norway": "Norwegen",
  "Netherlands": "Niederlande",
  "Nepal": "Nepal",
  "Morocco": "Marokko",
  "W. Sahara": "Westsahara",
  "Montenegro": "Montenegro",
  "Mongolia": "Mongolei",
  "Moldova": "Moldau",
  "Mauritania": "Mauretanien",
  "North Macedonia": "Nordmazedonien",
  "Luxembourg": "Luxemburg",
  "Lithuania": "Litauen",
  "Libya": "Libyen",
  "Lebanon": "Libanon",
  "Latvia": "Lettland",
  "Kyrgyzstan": "Kirgisistan",
  "Kuwait": "Kuwait",
  "Kosovo": "Kosovo",
  "Jordan": "Jordanien",
  "Italy": "Italien",
  "Israel": "Israel",
  "Palestine": "Palästina",
  "Ireland": "Irland",
  "Iraq": "Irak",
  "Iran": "Iran",
  "India": "Indien",
  "Iceland": "Island",
  "Hungary": "Ungarn",
  "Greece": "Griechenland",
  "Georgia": "Georgien",
  "Finland": "Finnland",
  "Estonia": "Estland",
  "Egypt": "Ägypten",
  "Denmark": "Dänemark",
  "Czechia": "Tschechien",
  "N. Cyprus": "Nordzypern",
  "Cyprus": "Zypern",
  "Croatia": "Kroatien",
  "China": "China",
  "Bulgaria": "Bulgarien",
  "Bosnia and Herz.": "Bosnien und Herzegowina",
  "Bhutan": "Bhutan",
  "Belgium": "Belgien",
  "Belarus": "Weißrussland",
  "Azerbaijan": "Aserbaidschan",
  "Austria": "Österreich",
  "Armenia": "Armenien",
  "Algeria": "Algerien",
  "Albania": "Albanien",
  "Afghanistan": "Afghanistan",
  "Siachen Glacier": "Siachen-Gletscher",
  "oklch(0.15 0.01 260)": "oklch(0.15 0.01 260)",
  "oklch(0.929 0.013 255.508)": "oklch(0.929 0.013 255.508)",
  "oklch(0.15 0.01 260 / 0.2)": "oklch(0.15 0.01 260 / 0.2)",
  "url(#tm-g)": "url(#tm-g)",
  "oklch(0.9 0.17 100 / 0.25)": "oklch(0.9 0.17 100 / 0.25)",
  "url(#df-g)": "url(#df-g)",
  "oklch(0.15 0.01 260 / 0.12)": "oklch(0.15 0.01 260 / 0.12)",
  "UTC": "UTC",
  "Roborock": "Roborock",
  "Lexar": "Lexar",
  "CUKTECH": "CUKTECH",
  "JONR": "JONR"
};

export default dict;
